import { render, staticRenderFns } from "./IDENTIFY_CONTENT.vue?vue&type=template&id=4b8c4b11"
import script from "./IDENTIFY_CONTENT.vue?vue&type=script&lang=js"
export * from "./IDENTIFY_CONTENT.vue?vue&type=script&lang=js"
import style0 from "./IDENTIFY_CONTENT.vue?vue&type=style&index=0&id=4b8c4b11&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports